"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Filter_1 = require("./Filter");
var FilterGroup = /** @class */ (function () {
    function FilterGroup(type) {
        if (type === void 0) { type = "AND"; }
        this.type = type;
        this.filters = [];
    }
    FilterGroup.prototype.where = function (column, value, operator) {
        if (operator === void 0) { operator = "="; }
        this.filters.push(new Filter_1.default(column, value, operator, "AND"));
        return this;
    };
    FilterGroup.prototype.orWhere = function (column, value, operator) {
        if (operator === void 0) { operator = "="; }
        this.filters.push(new Filter_1.default(column, value, operator, "OR"));
        return this;
    };
    FilterGroup.prototype.format = function (index) {
        var filters = this.filters.reduce(function (formated, filter, filterIndex) {
            return "".concat(formated).concat(formated ? " " : "").concat(filter.format(filterIndex));
        }, "");
        return "".concat(index === 0 ? "" : "".concat(this.type, " "), "(").concat(filters, ")");
    };
    return FilterGroup;
}());
exports.default = FilterGroup;
